import { json } from "body-parser";
import React, { FormEvent, useEffect, useState } from "react";
import { useModalHide } from "./comps/Modal";
import { sleep } from "./utils";

type EmailForm = {
    name: string
    email: string
    company: string
    message: string
}

function errorField(errorMessage: string, errorPattern:RegExp){
    if(errorMessage?.match(errorPattern)) return 'form-control is-invalid';
    return 'form-control'    
}

async function sendMessage(data:EmailForm){
    const res = await fetch('/send-email', {method: 'post', headers:{'content-type': 'application/json'}, body: JSON.stringify(data)})
    if(res.status == 200)
        return await res.json()
    
    throw (await res.json()).error
}

export function HireMeModal(){
    const [form, setForm] = useState<EmailForm>({name:"", email: "", company: "", message: ""})
    const [error, setError] = useState<string>(null);
    const [successed, setSuccessed] = useState(false);
    const [loading, setLoading] = useState(false);
    const hide = useModalHide()

    function validate(){
        if(!form.name) throw "Fill the name field.";
        if(!form.email) throw "Fill the email field.";
        if(!form.company) throw "Fill the company field.";
        if(form.message.length < 50) throw "The message field must have at least 50 characters.";
    }

    async function sendForm(e:FormEvent){
        e.preventDefault()
        if(loading) return;
        setLoading(true);
        try{
            await sleep(500);
            validate();
            await sendMessage(form)
            //throw "Not implemented!";
            setSuccessed(true);
        }catch(e){
            setError(e.message || e.toString())
        }
        setLoading(false);
    }

    useEffect(()=>setError(null), [form])

    if(successed)
        return <>
            <p className="text-center my-5">Thanks for reaching out! I’ll reply shortly.</p>
        </>

    return <form onSubmit={sendForm}>
        <p className="mb-4">Whether you’re planning a new project or improving an existing one,
            feel free to reach out using the form below.</p>
        <div className="form-floating mb-3">
            <input type="text" className={errorField(error, /name/i)} id="floatingName" placeholder="Your Name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />
            <label htmlFor="floatingName">Name:</label>
        </div>
        <div className="form-floating mb-3">
            <input type="email" className={errorField(error, /email/i)} id="floatingInput" placeholder="your-email@domain.com" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} />
            <label htmlFor="floatingInput">Email address:</label>
        </div>
        <div className="form-floating mb-3">
            <input type="text" className={errorField(error, /company/i)} id="floatingInput" placeholder="Company you represent" value={form.company} onChange={(e) => setForm({...form, company: e.target.value})} />
            <label htmlFor="floatingInput">Company:</label>
        </div>
        <div className="form-floating mb-3">
            <textarea className={errorField(error, /message/i)} placeholder="Leave a message here" id="floatingTextarea" style={{minHeight:"200px"}} value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} />
            <label htmlFor="floatingTextarea">Message:</label>
        </div>
        {
            error != null && <div className="alert alert-danger mb-3">
                <b>Error: </b>{error}
            </div>
        }
        <div className="text-end">
            <button className="btn btn-outline-primary me-2" onClick={(e) => {e.preventDefault(); hide();}}>Cancel</button>
            <button className="btn btn-primary me-2" type="submit">{loading && <i className="fa fa-spin fa-circle-notch me-2"></i>}Send Message</button>
        </div>
</form>
}